import { render, staticRenderFns } from "./FaceMatching.vue?vue&type=template&id=f469f332"
import script from "./FaceMatching.vue?vue&type=script&lang=js"
export * from "./FaceMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports